import { areCoordinatesEqual, type Coordinates } from "$lib/features/_other/coordinates.type";

export interface ViewState {
    center: Coordinates;
    zoom: number;
    pitch: number;
    bearing: number;
}

export function areViewStatesEqual(a: ViewState, b: ViewState): boolean {
    return (
        areCoordinatesEqual(a.center, b.center) &&
        a.zoom === b.zoom &&
        a.pitch === b.pitch &&
        a.bearing === b.bearing
    );
}